module.exports = __webpack_public_path__ + "static/media/sample11.0b21712f.jpg";